import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';
import {
  GET_PHARMACY_TEAM_LIST,
  CREATE_PHARMACY_USER,
  DELETE_PHARMACY_USER,
  ADD_PHARMACIES_TO_USER,
} from '../../services/urls';
import { getPharmacyId } from '../../utils/commonFunctions';

const initialState = {
  loading: false,
  teams: [],
  error: null,
  loadingAddTeams: false,
  addTeamsError: null,
};

export const fetchTeams = createAsyncThunk(
  'teams/fetchTeams',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${GET_PHARMACY_TEAM_LIST}/${getPharmacyId()}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch teams');
    }
  }
);

export const addTeams = createAsyncThunk(
  'teams/addTeams',
  async (newTeamData, { rejectWithValue }) => {
    try {
      const payload = {
        ...newTeamData,
        userRole: 2,
        pharmacyId: [getPharmacyId()],
      };
      if (!payload.password) {
        delete payload.password;
      }
      const response = await api.post(CREATE_PHARMACY_USER, payload);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to add team');
    }
  }
);

export const addPharmaciesToTeam = createAsyncThunk(
  'teams/addPharmaciesToTeam',
  async ({ userId, pharmacyIds }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `${ADD_PHARMACIES_TO_USER}/${userId}/pharmacies`,
        { pharmacyIds }
      );
      return response.data.data ?? response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to add pharmacies to team member'
      );
    }
  }
);

export const deleteTeams = createAsyncThunk(
  'teams/deleteTeams',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        `${DELETE_PHARMACY_USER}/${getPharmacyId()}/${userId}`
      );
      return response.data.data ?? response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to remove team member');
    }
  }
);

const teamsSlice = createSlice({
  name: 'teams',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeams.fulfilled, (state, action) => {
        state.loading = false;
        state.teams = action.payload;
      })
      .addCase(fetchTeams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addTeams.pending, (state) => {
        state.loadingAddTeams = true;
        state.addTeamsError = null;
      })
      .addCase(addTeams.fulfilled, (state) => {
        state.loadingAddTeams = false;
        state.addTeamsError = null;
      })
      .addCase(addTeams.rejected, (state, action) => {
        state.loadingAddTeams = false;
        state.addTeamsError = action.payload;
      });
  },
});

export default teamsSlice.reducer;
